<template>
  <a v-if="link" class="mb-btn">
    <slot/>
  </a>
  <button v-else class="mb-btn" @click="$emit('click', $event)">
    <slot/>
  </button>
</template>

<script>
  export default {
    name: 'Btn',
    props: {
      link: Boolean,
    },
  }
</script>

<style scoped lang="stylus">
  .mb-btn
    display block
    padding 9px 15px 8px
    margin 12px 0 7px
    border none
    border-radius 5px

    font-weight 500
    text-align center
    text-transform uppercase
    text-decoration none

    background-color #4ba3e2
    color #fff

    cursor pointer
</style>
